module.exports = __webpack_public_path__ + "static/media/back-arrow.79e15c0a.svg";